var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRemove(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "remove_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#remove_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.8 0h6.4a.8.8 0 010 1.6H4.8a.8.8 0 110-1.6zM1.6 3.2h12.8a.8.8 0 010 1.6h-.8v9.6A1.6 1.6 0 0112 16H4a1.6 1.6 0 01-1.6-1.6V4.8h-.8a.8.8 0 110-1.6zM4 4.8h8v9.6H4V4.8zM7.2 12V7.2a.8.8 0 10-1.6 0V12a.8.8 0 001.6 0zm3.25 0V7.2a.8.8 0 10-1.6 0V12a.8.8 0 001.6 0z",
    fillRule: "evenodd",
    fill: "currentColor"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRemove);
export default __webpack_public_path__ + "static/media/remove.197ab5aad5582f71921c16041fcc8876.svg";
export { ForwardRef as ReactComponent };